import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import { handleCloseDropdownOnBlur, setCaptchaEuScript } from '../utils';
import { getFormRenderToken } from '../services/anti-bot';
import { isCaptchaEnabled } from '../services/captcha';

Vue.component('become-partner-component', {
    props: {
        siteHandle: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            countryHandle: '',

            dropdownCountry: null,
            dropdownActivityLocation: null,

            isNumberValid: true,
        };
    },

    computed: {
        toggleButtonLoadingClass() {
            return this.submitting ? 'button--loading' : '';
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        //

        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }
        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });
        handleCloseDropdownOnBlur('#country-dropdown');
        handleCloseDropdownOnBlur('#activity-location-dropdown');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
                zenscroll.center(firstError);
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;
            let dataFromForm = new FormData(form);
            const data = {};

            for (let [key, val] of dataFromForm.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            if (!this.isNumberValid) {
                this.submitting = false;
                return;
            }

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                formData.append('formRenderToken', this.formRenderToken);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);
                const result = response.data;

                if (result.data.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);

                    this.submitting = false;
                    this.scrollToFirstError();
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();

                // this.scrollToTop();

                window.location = result.data.redirectUrl;
            } catch (e) {
                throw new Error(e);
            }
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        setDropdownCountry(event) {
            event.preventDefault();
            this[event.target.parentElement.dataset.dropdownName] =
                event.target.getAttribute('data-text');
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.countryHandle = value;
        },

        setDropdownActivityLocation(event) {
            event.preventDefault();
            this[event.target.parentElement.dataset.dropdownName] =
                event.target.innerHTML;
            this.toggleDropdown(event);

            // const value = event.currentTarget.dataset.value;
            // this.countryHandle = value
        },
    },
});
